import { render, staticRenderFns } from "./GoogleLookerStudioPage.vue?vue&type=template&id=2d237142&scoped=true&"
import script from "./GoogleLookerStudioPage.vue?vue&type=script&lang=js&"
export * from "./GoogleLookerStudioPage.vue?vue&type=script&lang=js&"
import style0 from "./GoogleLookerStudioPage.vue?vue&type=style&index=0&id=2d237142&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d237142",
  null
  
)

export default component.exports